<template>
  <v-container
    fluid
    class="page"
  >
    <v-card elevation="0">
      <v-card-title>
        <v-spacer />
        <v-text-field
          v-model="searchData"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        />
      </v-card-title>
      <v-card-text>
        <div class="d-flex">
          <v-dialog
            v-model="dialog"
            max-width="900"
            scrollable
          >
            <template #activator="{ on }">
              <v-btn
                color="#00ACDC"
                dark
                class="mb-2 ml-auto"
                v-on="on"
                @click="
                  type_id = assetType.toString();
                  metadata.cabinet_id = null;
                  handleCreateVehicle();
                "
              >
                CREATE NEW {{ getType(assetType) }}
              </v-btn>
            </template>
            <v-card
              width="100%"
              style="border-radius:10px;"
              class="pa-10"
              outlined
            >
              <v-toolbar
                light
                flat
              >
                <v-spacer />
                <div class="pt-3">
                  <p class="text-center headline">
                    <v-icon
                      color="#00ACDC"
                      class="mx-2"
                    >
                      mdi-truck-outline
                    </v-icon>Create {{ getType(assetType) }}
                  </p>
                </div>
                <div class="flex-grow-1" />
              </v-toolbar>
              <v-card-text class="my-0">
                <v-form
                  ref="form"
                  v-model="valid"
                  lazy-validation
                >
                  <v-container>
                    <v-row>
                      <v-col
                        cols="12"
                        sm="6"
                      >
                        <v-select
                          hide-details
                          :items="getVehicleType"
                          :item-text="(type) => `${type.name}`"
                          :item-value="(type) => `${type.id}`"
                          label="Select Vehicle Type"
                          outlined
                          v-model="type_id"
                          required
                          disabled
                          :rules="[(v) => !!v || 'Item is required']"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        sm="6"
                      >
                        <v-combobox
                          hide-details
                          :items="unusedGPSDeviceForCreate"
                          item-text="name"
                          item-value="id"
                          label="Select Vehicle"
                          outlined
                          v-model="vehicle_id"
                          required
                          :rules="[(v) => !!v || 'Item is required']"
                          @change="updateFormDeviceType"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        sm="12"
                      >
                        <v-text-field
                          type="text"
                          outlined
                          hide-details
                          value="1"
                          label="Device Name"
                          :rules="[(v) => !!v || 'Item is required']"
                          v-model="metadata.device_name"
                          required
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        sm="6"
                      >
                        <v-text-field
                          type="text"
                          outlined
                          hide-details
                          value="1"
                          label="Make"
                          :rules="[(v) => !!v || 'Item is required']"
                          v-model="metadata.device_make"
                          required
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        sm="6"
                      >
                        <v-text-field
                          type="text"
                          outlined
                          hide-details
                          value="1"
                          label="Model"
                          :rules="[(v) => !!v || 'Item is required']"
                          v-model="metadata.device_model"
                          required
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        sm="6"
                      >
                        <v-select
                          hide-details
                          :items="engineTypes"
                          :rules="[(v) => !!v || 'Item is required']"
                          label="Engine Type"
                          outlined
                          v-model="metadata.engine_type"
                          required
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        sm="6"
                      >
                        <v-text-field
                          type="text"
                          outlined
                          hide-details
                          value="1"
                          label="Plate"
                          :rules="[(v) => !!v || 'Item is required']"
                          v-model="metadata.device_plate"
                          required
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        sm="6"
                      >
                        <v-text-field
                          type="number"
                          outlined
                          hide-details
                          value=""
                          label="No Of Passenger"
                          :rules="[(v) => !!v || 'Item is required']"
                          v-model="metadata.seat_count"
                          required
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        sm="6"
                        v-if="isDarwin"
                      >
                        <v-text-field
                          type="text"
                          outlined
                          hide-details
                          value=""
                          label="Plant No"
                          :rules="[(v) => !!v || 'Item is required']"
                          v-model="metadata.plant_no"
                          required
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        sm="6"
                      >
                        <v-autocomplete
                          :items="origin"
                          :item-text="(origin) => `${origin.name}`"
                          :item-value="(origin) => `${origin.Id}`"
                          label="Select Origin"
                          append-icon="mdi-map-marker"
                          outlined
                          v-model="origin_id"
                          required
                          hide-details
                          :rules="[(v) => !!v || 'Item is required']"
                        >
                          <template #no-data>
                            <p class="my-0 px-3 pt-1 font-weight-light">
                              No data Origin available. You can create on
                              <b><router-link
                                to="/geofence"
                              >Geofence page</router-link></b>
                            </p>
                          </template>
                        </v-autocomplete>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="6"
                      >
                        <v-text-field
                          type="text"
                          outlined
                          hide-details
                          label="Parking Location"
                          v-model="metadata.parking_location"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        sm="6"
                        v-if="isWollongong || isIntimap"
                      >
                        <div class="d-flex flex-column">
                          <v-switch
                            v-model="colorEnabled"
                            label="Set Vehicle Color"
                            hide-details
                            class="my-0 pt-0"
                          />
                          <v-text-field
                            v-if="colorEnabled"
                            v-model="color"
                            type="color"
                            hide-details
                            dense
                            class="mt-0"
                          />
                        </div>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="12"
                        v-if="!isDarwin && !isVictrack"
                      >
                        <v-select
                          hide-details
                          :items="cabinets"
                          :item-text="(cabinet) => `${cabinet.name}`"
                          :item-value="(cabinet) => `${cabinet.id}`"
                          label="Select Cabinet"
                          outlined
                          v-model="metadata.cabinet_id"
                          @change="metadata.cabinet_item_number = null"
                          clearable
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        sm="12"
                        v-if="metadata.cabinet_id && !isDarwin"
                      >
                        <v-select
                          hide-details
                          :items="cabinetItemsForCreate"
                          item-text="number"
                          item-value="number"
                          label="Select Key Cabinet Number"
                          no-data-text="No item available, please select other cabinet"
                          outlined
                          :rules="[(v) => {
                            if (!!metadata.cabinet_id) {
                              return !!v || 'Please select cabinet item number!';
                            }
                            return false;
                          }]"
                          v-model="metadata.cabinet_item_number"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        md="12"
                      >
                        <v-combobox
                          :items="vehicleGroupsForCreate"
                          item-text="name"
                          item-value="id"
                          :item-disabled="isGroupDisabled"
                          v-model="selectedVehicleGroups"
                          outlined
                          required
                          multiple
                          hide-details
                        >
                          <template #label>
                            <span>Asset Group</span>
                          </template>
                        </v-combobox>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="4"
                        md="4"
                      >
                        <v-checkbox
                          dense
                          hide-details
                          v-model="features.root_rack"
                          label="Roof Rack"
                          color="success"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        sm="4"
                        md="4"
                      >
                        <v-checkbox
                          hide-details
                          dense
                          v-model="features.baby_seat"
                          label="Baby Seat"
                          color="success"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        sm="4"
                        md="4"
                      >
                        <v-checkbox
                          dense
                          hide-details
                          v-model="features.child_capsule"
                          label="Roof Child Capsule"
                          color="success"
                        />
                      </v-col>
                      <v-row
                        class="mx-0"
                        v-for="(item, index) in accessories"
                        :key="index"
                      >
                        <v-col
                          cols="12"
                          sm="4"
                          md="4"
                          v-for="(accessory, index) in item"
                          :key="index"
                        >
                          <v-checkbox
                            dense
                            hide-details
                            :label="accessory"
                            color="success"
                            v-model="metadata.accessories"
                            :value="accessory"
                          />
                        </v-col>
                      </v-row>
                      <v-col sm="12">
                        <v-combobox
                          v-model="workingDaysObject"
                          :items="listWorkingDays"
                          label="Select Available Days"
                          multiple
                          chips
                          outlined
                          hide-details
                          item-text="name"
                          item-value="value"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        sm="6"
                      >
                        <v-dialog
                          ref="dialog"
                          v-model="modal"
                          :return-value.sync="start"
                          persistent
                          width="290px"
                        >
                          <template #activator="{ on, attrs }">
                            <v-text-field
                              v-model="start"
                              label="Start Available Time"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              outlined
                              clearable
                              hide-details
                            />
                          </template>
                          <v-time-picker
                            v-if="modal"
                            v-model="start"
                            full-width
                          >
                            <v-spacer />
                            <v-btn
                              text
                              color="primary"
                              @click="modal = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.dialog.save(start)"
                            >
                              OK
                            </v-btn>
                          </v-time-picker>
                        </v-dialog>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="6"
                      >
                        <v-dialog
                          ref="dialog2"
                          v-model="modal2"
                          :return-value.sync="end"
                          persistent
                          width="290px"
                        >
                          <template #activator="{ on, attrs }">
                            <v-text-field
                              v-model="end"
                              label="End Available Time"
                              clearable
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              outlined
                              hide-details
                            />
                          </template>
                          <v-time-picker
                            v-if="modal2"
                            v-model="end"
                            full-width
                          >
                            <v-spacer />
                            <v-btn
                              text
                              color="primary"
                              @click="modal2 = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.dialog2.save(end)"
                            >
                              OK
                            </v-btn>
                          </v-time-picker>
                        </v-dialog>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-form>
              </v-card-text>
              <v-divider />
              <v-card-actions>
                <v-row>
                  <v-col
                    cols="6"
                    sm="6"
                  >
                    <v-btn
                      @click="close"
                      block
                      type="submit"
                      color="error"
                    >
                      CLOSE
                    </v-btn>
                  </v-col>
                  <v-col
                    cols="6"
                    sm="6"
                  >
                    <v-btn
                      @click="saveCreate"
                      block
                      type="submit"
                      color="success"
                      :loading="loadingUpdate"
                      :disabled="loadingUpdate"
                    >
                      SUBMIT
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
        <v-data-table
          :headers="headers"
          :items="dataTableItems"
          class="font-weight-light pa-5 my-data-table"
          :loading="loadingData"
          loading-text="Loading..."
          :footer-props="footerProps"
          @update:options="updatePaging"
          :server-items-length="vehicleTotal"
          :options.sync="paginationOptions"
        >
          <template #[`item.no`]=" { item }">
            {{ ((paginationOptions.page - 1) * paginationOptions.itemsPerPage) + dataTableItems.indexOf(item) + 1 }}
          </template>
          <template #[`item.cabinet_item_number`]="{ item }">
            {{ item.cabinet_item_number > 0 ? item.cabinet_item_number : "" }}
          </template>
          <template #[`item.origin_id`]="{ item }">
            {{ getOriginName(item) }}
          </template>
          <template #[`item.assetGroups`]="{ item }">
            {{ item.assetGroups.length > 0
              ? item.assetGroups.map(group => group.name).join(", ")
              : "-"
            }}
          </template>
          <template #[`item.action`]="{ item }">
            <v-icon
              small
              class="mr-2"
              color="green"
              @click="editItem(item)"
            >
              mdi-pencil
            </v-icon>
            <v-icon
              small
              @click="deleteItem(item)"
              color="red"
            >
              mdi-delete
            </v-icon>
          </template>
          <template #[`item.metadata.features`]="{ item }">
            <div
              v-if="item.metadata.features.root_rack"
              class="font-weight-normal"
            >
              <v-icon
                x-small
                color="success"
              >
                mdi-check-circle
              </v-icon> Roof
              Rack
            </div>
            <div
              v-if="item.metadata.features.baby_seat"
              class="font-weight-normal"
            >
              <v-icon
                x-small
                color="success"
              >
                mdi-check-circle
              </v-icon> Baby
              Seat
            </div>
            <div
              v-if="item.metadata.features.child_capsule"
              class="font-weight-normal"
            >
              <v-icon
                x-small
                color="success"
              >
                mdi-check-circle
              </v-icon> Child
              Capsule
            </div>
            <div
              v-if="
                !item.metadata.features.root_rack &&
                  !item.metadata.features.baby_seat &&
                  !item.metadata.features.child_capsule
              "
              class="font-weight-normal"
            >
              -
            </div>
          </template>
          <template #no-data>
            Vehicle not available, please create a new vehicle
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <v-dialog
      v-model="deldialog"
      persistent
      max-width="500"
    >
      <v-card
        dark
        color="red"
      >
        <v-card-title>
          <span>
            <v-icon>mdi-alert-circle</v-icon> Are you sure to want to delete
            this vehicle?
          </span>
        </v-card-title>
        <v-card-text>
          You will delete this vehicle from {{ getType(assetType) }}.
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            @click="deldialog = false"
          >
            No
          </v-btn>
          <v-btn
            text
            @click="deleteVehicle()"
            :loading="loadingUpdate"
            :disabled="loadingUpdate"
          >
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="editdialog"
      max-width="900"
      scrollable
    >
      <v-card
        width="100%"
        style="border-radius:10px;"
        class="pa-10"
        outlined
      >
        <v-toolbar
          light
          flat
        >
          <v-spacer />
          <div class="pt-3">
            <p class="text-center headline">
              <v-icon
                color="#00ACDC"
                class="mx-2"
              >
                mdi-truck-outline
              </v-icon>Edit Vehicle
            </p>
          </div>
          <div class="flex-grow-1" />
        </v-toolbar>
        <v-card-text class="my-0">
          <v-form
            ref="formEdit"
            v-model="valid"
            lazy-validation
          >
            <v-container>
              <v-row>
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-select
                    hide-details
                    :items="getVehicleType"
                    :item-text="(type) => `${type.name}`"
                    :item-value="(type) => `${type.id}`"
                    label="Select Vehicle Type"
                    outlined
                    v-model="editedItem.type_id"
                    required
                    :rules="[(v) => !!v || 'Item is required']"
                    disabled
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-combobox
                    hide-details
                    :items="unusedGPSDeviceForEdit"
                    item-text="name"
                    item-value="id"
                    label="Select Vehicle"
                    outlined
                    v-model="editedItem.selectedVehicle"
                    required
                    :rules="[(v) => !!v || 'Item is required']"
                    @change="updateFormDeviceTypeForEdit"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                >
                  <v-text-field
                    type="text"
                    outlined
                    hide-details
                    value="1"
                    label="Device Name"
                    :rules="[(v) => !!v || 'Item is required']"
                    v-model="editedItem.metadata.device_name"
                    required
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-text-field
                    type="text"
                    outlined
                    hide-details
                    value="1"
                    label="Make"
                    :rules="[(v) => !!v || 'Item is required']"
                    v-model="editedItem.metadata.device_make"
                    required
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-text-field
                    type="text"
                    outlined
                    hide-details
                    value="1"
                    label="Model"
                    :rules="[(v) => !!v || 'Item is required']"
                    v-model="editedItem.metadata.device_model"
                    required
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-select
                    hide-details
                    :items="engineTypes"
                    :rules="[(v) => !!v || 'Item is required']"
                    label="Engine Type"
                    outlined
                    v-model="editedItem.metadata.engine_type"
                    required
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-text-field
                    type="text"
                    outlined
                    hide-details
                    value="1"
                    label="Plate"
                    :rules="[(v) => !!v || 'Item is required']"
                    v-model="editedItem.metadata.device_plate"
                    required
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-text-field
                    type="number"
                    outlined
                    hide-details
                    value=""
                    label="No Of Passenger"
                    :rules="[(v) => !!v || 'Item is required']"
                    v-model="editedItem.metadata.seat_count"
                    required
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  v-if="isDarwin"
                >
                  <v-text-field
                    type="text"
                    outlined
                    hide-details
                    value=""
                    label="Plant No"
                    :rules="[(v) => !!v || 'Item is required']"
                    v-model="editedItem.metadata.plant_no"
                    required
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-autocomplete
                    :items="origin"
                    :item-text="(origin) => `${origin.name}`"
                    :item-value="(origin) => `${origin.Id}`"
                    label="Select Origin"
                    append-icon="mdi-map-marker"
                    outlined
                    v-model="editedItem.origin_id"
                    required
                    hide-details
                    :rules="[(v) => !!v || 'Item is required']"
                  >
                    <template #no-data>
                      <p class="my-0 px-3 pt-1 font-weight-light">
                        No data Origin available. You can create on
                        <b><router-link
                          to="/geofence"
                        >Geofence page</router-link></b>
                      </p>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-text-field
                    type="text"
                    outlined
                    hide-details
                    label="Parking Location"
                    v-model="editedItem.metadata.parking_location"
                    required
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  v-if="isWollongong || isIntimap"
                >
                  <div class="d-flex flex-column">
                    <v-switch
                      v-model="colorEnabled"
                      label="Set Vehicle Color"
                      hide-details
                      class="my-0 pt-0"
                    />
                    <v-text-field
                      v-if="colorEnabled"
                      v-model="color"
                      type="color"
                      hide-details
                      dense
                      class="mt-0"
                    />
                  </div>
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  v-if="!isDarwin && !isVictrack"
                >
                  <v-select
                    hide-details
                    :items="cabinets"
                    :item-text="(cabinet) => `${cabinet.name}`"
                    :item-value="(cabinet) => `${cabinet.id}`"
                    label="Select Cabinet"
                    outlined
                    v-model="editedItem.metadata.cabinet_id"
                    @change="editedItem.metadata.cabinet_item_number = null"
                    :disabled="!cabinetLoaded"
                    clearable
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  v-if="editedItem.metadata.cabinet_id && cabinetLoaded"
                >
                  <v-select
                    hide-details
                    :items="cabinetItemsForEdit"
                    item-text="number"
                    item-value="number"
                    label="Select Key Cabinet Number"
                    no-data-text="No item available, please select other cabinet"
                    outlined
                    v-model="editedItem.metadata.cabinet_item_number"
                    :rules="[(v) => {
                      if (!!editedItem.metadata.cabinet_id) {
                        return !!v || 'Please select cabinet item number!';
                      }
                      return false;
                    }]"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="12"
                >
                  <v-combobox
                    :items="vehicleGroupsForEdit"
                    item-text="name"
                    item-value="id"
                    :item-disabled="isGroupDisabled"
                    v-model="selectedVehicleGroups"
                    outlined
                    multiple
                    hide-details
                  >
                    <template #label>
                      <span>Asset Group</span>
                    </template>
                  </v-combobox>
                </v-col>
                <v-col
                  cols="12"
                  sm="4"
                  md="4"
                >
                  <v-checkbox
                    dense
                    hide-details
                    v-model="editedItem.metadata.features.root_rack"
                    label="Roof Rack"
                    color="success"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="4"
                  md="4"
                >
                  <v-checkbox
                    hide-details
                    dense
                    v-model="editedItem.metadata.features.baby_seat"
                    label="Baby Seat"
                    color="success"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="4"
                  md="4"
                >
                  <v-checkbox
                    dense
                    hide-details
                    v-model="editedItem.metadata.features.child_capsule"
                    label="Roof Child Capsule"
                    color="success"
                  />
                </v-col>
                <v-row
                  class="mx-0"
                  v-for="(item, index) in accessories"
                  :key="index"
                >
                  <v-col
                    cols="12"
                    sm="4"
                    md="4"
                    v-for="(accessory, index) in item"
                    :key="index"
                  >
                    <v-checkbox
                      dense
                      hide-details
                      :label="accessory"
                      color="success"
                      v-model="editedItem.metadata.accessories"
                      :value="accessory"
                    />
                  </v-col>
                </v-row>
                <v-col sm="12">
                  <v-combobox
                    ref="workingDays"
                    v-model="editedItem.metadata.working_day"
                    :items="listWorkingDays"
                    label="Select Available Days"
                    multiple
                    chips
                    outlined
                    hide-details
                    item-text="name"
                    item-value="value"
                    persistent-hint
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-dialog
                    ref="dialog"
                    v-model="modal"
                    :return-value.sync="editedItem.metadata.working_time.start"
                    persistent
                    width="290px"
                  >
                    <template #activator="{ on, attrs }">
                      <v-text-field
                        v-model="editedItem.metadata.working_time.start"
                        label="Start Available Time"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        outlined
                        hide-details
                        clearable
                      />
                    </template>
                    <v-time-picker
                      v-if="modal"
                      v-model="editedItem.metadata.working_time.start"
                      full-width
                    >
                      <v-spacer />
                      <v-btn
                        text
                        color="primary"
                        @click="modal = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.dialog.save(editedItem.metadata.working_time.start)"
                      >
                        OK
                      </v-btn>
                    </v-time-picker>
                  </v-dialog>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-dialog
                    ref="dialog2"
                    v-model="modal2"
                    :return-value.sync="editedItem.metadata.working_time.end"
                    persistent
                    width="290px"
                  >
                    <template #activator="{ on, attrs }">
                      <v-text-field
                        v-model="editedItem.metadata.working_time.end"
                        label="End Available Time"
                        clearable
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        outlined
                        hide-details
                      />
                    </template>
                    <v-time-picker
                      v-if="modal2"
                      v-model="editedItem.metadata.working_time.end"
                      full-width
                    >
                      <v-spacer />
                      <v-btn
                        text
                        color="primary"
                        @click="modal2 = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.dialog2.save(editedItem.metadata.working_time.end)"
                      >
                        OK
                      </v-btn>
                    </v-time-picker>
                  </v-dialog>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-row>
            <v-col
              cols="6"
              sm="6"
            >
              <v-btn
                @click="closeEdit"
                block
                type="submit"
                color="error"
              >
                CLOSE
              </v-btn>
            </v-col>
            <v-col
              cols="6"
              sm="6"
            >
              <v-btn
                @click="saveEdit"
                block
                type="submit"
                color="success"
                :loading="loadingUpdate"
                :disabled="loadingUpdate"
              >
                SUBMIT
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
const qs = require("qs");
import get from "lodash/get"
import cloneDeep from "lodash/cloneDeep"
import trim from "lodash/trim"
import isUndefined from "lodash/isUndefined"
import chunk from "lodash/chunk"

export default {
  props: {
    assetType: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    listWorkingDays: [
      { name: "Sunday", value: 0 },
      { name: "Monday", value: 1 },
      { name: "Tuesday", value: 2 },
      { name: "Wednesday", value: 3 },
      { name: "Thursday", value: 4 },
      { name: "Friday", value: 5 },
      { name: "Saturday", value: 6 }
    ],
    workingDaysObject: [],
    colorEnabled: false,
    color: '#1976D2',
    modal: "",
    modal2: "",
    start: "",
    end: "",
    headers: [],
    deldialog: false,
    dataGPSDevice: [],
    origin_id: "",
    dialog: false,
    editdialog: false,
    deletedIndex: null,
    deletedItem: {},
    editedIndex: null,
    no_available_periode: {
      start_date: "",
      end_date: "",
    },
    editId: null,
    editedItem: {
      deviceid: "",
      type_id: "",
      clientid: "",
      id: "",
      origin_id: "",
      metadata: {
        seat_count: "",
        plant_no: "",
        engine_type: "",
        features: {
          root_rack: false,
          baby_seat: false,
          child_capsule: false,
        },
        no_available_periode: {
          start_date: "",
          end_date: "",
        },
        parking_location: "",
        vehicle_color: "",
        cabinet_id: "",
        cabinet_item_number: "",
        device_name: "",
        device_make: "",
        device_model: "",
        device_plate: "",
        working_day: [],
        working_time: {
          start: "",
          end: "",
        },
        accessories: [],
      },
    },
    token: "",
    clientid: "",
    canShare: false,
    getVehicle: [],
    getVehicleType: [],
    valid: true,
    engineTypes: [
      "Petrol",
      "Diesel",
      "Electric",
      "Petrol Electric Hybrid",
      "Diesel Electric Hybrid",
      "Hydrogen",
    ],
    payloadApi: {},
    vehicle_id: "",
    type_id: "",
    metadata: {
      seat_count: "",
      plant_no: "",
      engine_type: "",
      parking_location: "",
      vehicle_color: "",
      cabinet_id: "",
      cabinet_item_number: "",
      device_name: "",
      device_make: "",
      device_model: "",
      device_plate: "",
      working_day: [],
      working_time: {
        start: "",
        end: "",
      },
      accessories: [],
    },
    features: {
      root_rack: false,
      baby_seat: false,
      child_capsule: false,
    },
    editedfeatures: {
      root_rack: false,
      baby_seat: false,
      child_capsule: false,
    },
    cabinetsUsage: [],
    loadingData: false,
    loadingUpdate: false,
    searchData: "",
    searchDataTimeout: null,
    vehicleTotal: 0,
    footerProps: {
      itemsPerPageOptions: [2, 3, 5, 10, 20, 50, 100, 200, 500]
    },
    paginationOptions: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: []
    },
    vehicleGroups: [],
    selectedVehicleGroups: [],
    accessories: [],
  }),
  created() {
    this.getTypeVehicles();
    this.loadData();
    this.$store.commit("CLEAR_CABINETS");
    this.$store.dispatch("GET_GEOFENCES");
    this.$store.dispatch("LOAD_CABINETS");

    if (!this.isDarwin) {
      this.headers = [
        { text: "No", value: "no", sortable: false },
        { text: "Make", value: "device_make" },
        { text: "Model", value: "device_model" },
        { text: "Engine", value: "metadata.engine_type", sortable: false },
        { text: "Name", value: "device_name" }
      ];

      if (this.isVictrack) {
        this.headers.push({ text: "Origin", value: "origin_id", sortable: false });
      } else {
        this.headers.push({ text: "Cabinet", value: "cabinet_name" });
        this.headers.push({ text: "Cabinet Item No.", value: "cabinet_item_number", class: "cabinet-item-no-col"});
      }

      this.headers.push({ text: "Seat", value: "metadata.seat_count", sortable: false });
      this.headers.push({ text: "Parking Location", value: "metadata.parking_location", sortable: false, class: "cabinet-item-no-col" });
      this.headers.push({ text: "Asset Groups", value: "assetGroups", sortable: false });

      if (this.isWSP) {
        this.headers.push({ text: "Accessories", value: "metadata.accessories" });
      }

      this.headers.push({ text: "Actions", value: "action", sortable: false });
    } else {
      this.headers = [
        { text: "No", value: "no", sortable: false },
        { text: "Make", value: "device_make" },
        { text: "Model", value: "device_model" },
        { text: "Engine", value: "metadata.engine_type", sortable: false },
        { text: "Name", value: "device_name" },
        { text: "Seat", value: "metadata.seat_count", sortable: false },
        { text: "Parking Location", value: "metadata.parking_location", sortable: false },
        { text: "Plant No", value: "metadata.plant_no" },
        { text: "Features", value: "metadata.features", sortable: false },
        { text: "Actions", value: "action", sortable: false },
      ];
    }
  },
  computed: {
    isDarwin() {
      return this.$store.state.clientid === "ED73T6OILP78";
    },
    isVictrack() {
      return this.$store.state.clientid === "E4IKWG0LDBM8";
    },
    isWSP() {
      return this.$store.state.clientid == 'H1O5G7P0N3JA';
    },
    isIntimap() {
      return this.$store.state.clientid == 'DSSTWWLLIHH7';
    },
    isWollongong() {
      return this.$store.state.clientid == 'A506MF91OINZ';
    },
    geofences() {
      return this.$store.getters["getGeofencesData"];
    },
    origin() {
      if (this.geofences[this.$store.state.clientid]) {
        const groups = this.geofences[this.$store.state.clientid].filter(
          (group) =>
            group.name === "Carpool Origin" ||
            group.name === "Carpool Origin - Destination" ||
            group.name === "Carpool Origin without Key Cabinet"
        );
        const geofences = [];

        // eslint-disable-next-line no-unused-vars
        groups.forEach((group, i) => {
          // eslint-disable-next-line no-unused-vars
          group.geofences.forEach((geofence, i) => {
            geofences.push(geofence);
          });
        });
        // eslint-disable-next-line no-console
        return geofences.sort((a, b) => {
          return a.name.localeCompare(b.name);
        });
      }

      return [];
    },
    cabinetLoaded() {
      return this.$store.getters["getCabinetLoaded"];
    },
    cabinets() {
      return this.$store.getters["getCabinets"];
    },
    currentFilteredVehicle() {
      return this.getVehicle.filter(
        (vehicle) => parseInt(vehicle.type_id) === parseInt(this.assetType)
      );
    },
    dataTableItems() {
      return this.currentFilteredVehicle.map((v) => {
        v.device_name = v.metadata.device_name || v.device_name
        v.device_plate = v.metadata.device_plate || v.device_plate
        v.device_make = v.metadata.device_make || v.device_make
        v.device_model = v.metadata.device_model || v.device_model.split('^')[0]
        v.cabinet_name = this.cabinetName(v)
        v.assetGroups = v.groups.filter(g => g.id);
        return v;
      });
    },
    noGpsInstalled() {
      return this.vehicle_id && parseInt(this.vehicle_id.id, 10) === -1;
    },
    unusedGPSDeviceForCreate() {
      const devices = this.dataGPSDevice.filter(dev => !dev.type_id && dev.deviceid !== null);
      devices.unshift({
        name: '== No GPS Installed ==',
        id: '-1',
      });
      return devices;
    },
    unusedGPSDeviceForEdit() {
      const devices = this.dataGPSDevice.filter((dev) => {
        return (!dev.type_id || dev.id === this.editId) && dev.deviceid !== null;
      });
      devices.unshift({
        name: '== No GPS Installed ==',
        id: '-1',
      });
      return devices;
    },
    cabinetItemsForCreate() {
      let cabinet_id = null;

      if (this.metadata.cabinet_id) {
        cabinet_id = this.metadata.cabinet_id;
      }

      const cabinet = this.cabinets.find(
        (cabinet) => cabinet.id === cabinet_id
      );

      if (!cabinet) return [];

      const matchCabinet = this.cabinetsUsage.find((c) => c.cabinet === cabinet_id);
      let items = get(cabinet, "items", []);

      if (!matchCabinet) return items;

      return items.filter((i) => {
        const itemNo = parseInt(i.number, 10);
        const used = matchCabinet.items
          .find((ui) => parseInt(ui.item_no, 10) === itemNo);
        return !used;
      }).map(({ number }) => ({ number: number.toString() }));
    },
    cabinetItemsForEdit() {
      let cabinet_id = null;

      if (this.editedItem.metadata.cabinet_id) {
        cabinet_id = this.editedItem.metadata.cabinet_id;
      }

      const cabinet = this.cabinets.find(
        (cabinet) => cabinet.id === cabinet_id
      );

      if (!cabinet) return [];

      const matchCabinet = this.cabinetsUsage.find((c) => c.cabinet === cabinet_id);
      let items = get(cabinet, "items", []);

      if (!matchCabinet) return items;

      return items.filter((i) => {
        const itemNo = parseInt(i.number, 10);
        const used = matchCabinet.items
          .find((ui) => parseInt(ui.item_no, 10) === itemNo);
        const editedAsset = this.getVehicle[this.editedIndex];
        if (!editedAsset) return !used;
        if (editedAsset.metadata.cabinet_id === cabinet_id) {
          const currentItemNo = parseInt(editedAsset.metadata.cabinet_item_number, 10);
          if (!isNaN(currentItemNo) && itemNo === currentItemNo) {
            return true;  
          }
        }
        return !used;
      }).map(({ number }) => ({ number: number.toString() }));
    },
    vehicleGroupsForCreate() {
      return this.vehicleGroups.filter((group) => {
        const isSameType = parseInt(get(group, 'metadata.asset_type', 0), 10) === parseInt(this.assetType, 10);
        const isSpecial = this.getValueAsBoolean(get(group, 'metadata.is_special', false));
        return isSameType || (this.isAdmin && isSpecial);
      });
    },
    vehicleGroupsForEdit() {
      return this.vehicleGroups.filter((group) => {
        const isSameType = parseInt(get(group, 'metadata.asset_type', 0), 10) === parseInt(this.assetType, 10);
        const isSpecial = this.getValueAsBoolean(get(group, 'metadata.is_special', false));
        const isCurrentGroup = this.selectedVehicleGroups.find(g => g.id == group.id);
        return isCurrentGroup || isSameType || (this.isAdmin && isSpecial);
      });
    },
    isAdmin() {
      return this.getValueAsBoolean(get(this, '$store.state.type', false));
    },
  },
  mounted() {
    this.getDataAccessories();
  },
  watch: {
    type_id(value) {
      const item = this.getVehicleType.find((d) => d.id == value);
      item.ride_share =
        typeof item.ride_share === "string"
          ? parseInt(item.ride_share)
          : item.ride_share;
      if (item.ride_share == 1) {
        this.canShare = true;
      }
    },
    "no_available_periode.start_date"() {},
    searchData(query) {
      clearTimeout(this.searchDataTimeout)
      this.searchDataTimeout = setTimeout(() => {
        this.paginationOptions.page    = 1;
        this.paginationOptions.sortBy  = [];
        this.paginationOptions.sortDesc = [];
        this.getVehicleTotal();
        this.getDataVehicles();
      }, 1e3)
    }
  },
  methods: {
    isGroupDisabled(item) {
      const group = this.vehicleGroups.find(g => g.id === item.id);
      const isSpecial = this.getValueAsBoolean(get(group, 'metadata.is_special', false));
      return isSpecial;
    },
    getOriginName(vehicle) {
      const origin = this.origin.find((o) => o.Id == vehicle.origin_id);
      return origin ? origin.name : "";
    },
    getValueAsBoolean(value) {
      return value == 1 || value == '1' || value == 'true' || value == true ? 1 : 0;
    },
    getDataAccessories() {
      this.$store
        .dispatch("API_CALL", {
          $method: "get_vehicle_accessory",
          $postData: {
            clientid: this.$store.state.clientid
          }
        })
        .then(response => {
          this.accessories = response.data.data.map(item => {
            return item.name;
          });
          this.accessories = chunk(this.accessories, 3);
        });
    },
    getDataVehicleGroups() {
      this.$store
        .dispatch("API_CALL", {
          $method: "get_asset_groups",
          $postData: {
            clientid: this.$store.state.clientid,
            show_detail: 0
          }
        })
        .then(response => {
          this.vehicleGroups = response.data.data.map(item => {
            item.metadata = item.metadata || {};
            item.metadata.asset_type = item.metadata.asset_type || 0;
            item.metadata.is_special = this.getValueAsBoolean(item.metadata.is_special);
            return item;
          });
        });
    },
    loadData() {
      if (this.loadingData) return;
      this.loadingData = true;
      return Promise.all([
        this.getGPSDevice(),
        this.getVehicleTotal(),
        this.loadCabinetsUsage(),
        this.getDataVehicleGroups(),
      ]).finally(() => {
        this.getDataVehicles(),
        this.loadingData = false;
      });
    },
    getGPSDevice() {
      this.token = this.$store.state.token;
      return this.$store.dispatch('API_CALL', {
          $method: 'get_all_gps_device',
          $postData: {
            clientid: this.$store.state.clientid,
          },
        })
        .then((response) => {
          this.dataGPSDevice = response.data ? response.data.data : [];
          this.dataGPSDevice = this.dataGPSDevice.filter((device) => parseInt(device.deviceid));
        });
    },
    loadCabinetsUsage() {
      const { clientid } = this.$store.state;
      return this.$store.dispatch('API_CALL', {
          $method: 'get_cabinets_usage',
          $postData: {
            clientid,
          },
        })
        .then((response) => {
          if (response && response.data && response.data.data) {
            this.cabinetsUsage = response.data.data;
          }
        });
    },
    updateFormDeviceType() {
      this.metadata.device_name = '';
      this.metadata.device_make = '';
      this.metadata.device_model = '';
      this.metadata.device_plate = '';
      this.$refs.form.resetValidation();

      if (this.vehicle_id.id !== '-1') {
        this.metadata.device_name = this.vehicle_id.name;
        this.metadata.device_make = this.vehicle_id.make;
        this.metadata.device_model = this.vehicle_id.model.split('^')[0];
        this.metadata.device_plate = this.vehicle_id.reg.split('^')[0];
      }
    },
    updateFormDeviceTypeForEdit() {
      const editedItem = this.editedItem;
      const metadata = editedItem.metadata || {};
      metadata.device_name = '';
      metadata.device_make = '';
      metadata.device_model = '';
      metadata.device_plate = '';
      this.$refs.formEdit.resetValidation();

      if (editedItem.selectedVehicle) {
        if (editedItem.selectedVehicle.id !== '-1') {
          metadata.device_name = editedItem.selectedVehicle.name;
          metadata.device_make = editedItem.selectedVehicle.make;
          metadata.device_model = editedItem.selectedVehicle.model.split('^')[0];
          metadata.device_plate = editedItem.selectedVehicle.reg.split('^')[0];
        } else {
          const vehicle = this.getVehicle.find(v => v.id === this.editId);
          if (vehicle) {
            metadata.device_name = vehicle.metadata.device_name;
            metadata.device_make = vehicle.metadata.device_make;
            metadata.device_model = vehicle.metadata.device_model;
            metadata.device_plate = vehicle.metadata.device_plate;
          }
        }
      }
    },
    getTypeVehicles() {
      this.token = this.$store.state.token;
      this.$store.dispatch('API_CALL', {
          $method: 'get_asset_types',
          $postData: {
            clientid: this.$store.state.clientid,
          },
        })
        .then((response) => {
          this.getVehicleType = response.data.data.filter(
            (type) => parseInt(type.is_vehicle) === 1
          );
        });
    },
    saveEdit() {
      if (this.$refs.formEdit.validate()) {
        this.token = this.$store.state.token;
        this.editdialog = false;
        const metadatas = {
          seat_count: this.editedItem.metadata.seat_count,
          plant_no: this.editedItem.metadata.plant_no,
          engine_type: this.editedItem.metadata.engine_type,
          parking_location: trim(this.editedItem.metadata.parking_location),
          color_enabled: this.colorEnabled ? 1 : 0,
          vehicle_color: this.color,
          features: this.editedfeatures,
          cabinet_id: this.editedItem.metadata.cabinet_id,
          cabinet_item_number: this.editedItem.metadata.cabinet_item_number,

          device_name: trim(this.editedItem.metadata.device_name),
          device_make: trim(this.editedItem.metadata.device_make),
          device_model: trim(this.editedItem.metadata.device_model),
          device_plate: trim(this.editedItem.metadata.device_plate),
          working_day: this.editedItem.metadata.working_day.map(day => day.value),
          working_time: {
            start: this.editedItem.metadata.working_time.start,
            end: this.editedItem.metadata.working_time.end,
          },
          accessories: this.editedItem.metadata.accessories ? this.editedItem.metadata.accessories : [],
        };

        this.loadingUpdate = true;
        const newDeviceId = this.editedItem.selectedVehicle.id === '-1' ?
          '' : this.editedItem.selectedVehicle.deviceid;``

        let deviceid = this.editedItem.deviceid;
        if (deviceid === '-1') deviceid = '';

      const groups = this.selectedVehicleGroups.length ? this.selectedVehicleGroups.map(g => g.id).join(',') : '';

        this.$store.dispatch('API_CALL', {
            $method: 'update_vehicle',
            $postData: {
              id: this.editedItem.id,
              type_id: this.editedItem.type_id,
              clientid: this.$store.state.clientid,
              deviceid: deviceid,
              new_deviceid: newDeviceId,
              metadata: metadatas,
              origin_id: this.editedItem.origin_id,
              groups,
            },
          })
          .then(
            // Object.assign(this.getVehicle[this.editedIndex], this.editedItem)
            (response) => {
              this.loadingUpdate = false;
              if (response.data.code == 200) {
                // Object.assign(this.getVehicle[this.editedIndex], this.editedItem)
                this.$swal({
                  icon: "success",
                  title: response.data.data.message,
                });
                this.loadData();
              } else {
                this.$swal({
                  icon: "error",
                  title: response.data.data.message,
                });
              }
            }
          );
      }
    },
    saveCreate() {
      if (this.$refs.form.validate()) {
        this.token = this.$store.state.token;
        this.dialog = false;
        var metadatas = {
          seat_count: this.metadata.seat_count,
          plant_no: this.metadata.plant_no,
          engine_type: this.metadata.engine_type,
          parking_location: trim(this.metadata.parking_location),
          color_enabled: this.colorEnabled ? 1 : 0,
          vehicle_color: this.color,
          features: this.features,
          cabinet_id: this.metadata.cabinet_id,
          cabinet_item_number: this.metadata.cabinet_item_number,
          device_name: trim(this.metadata.device_name),
          device_make: trim(this.metadata.device_make),
          device_model: trim(this.metadata.device_model),
          device_plate: trim(this.metadata.device_plate),
          working_day: this.workingDaysObject.map(day => day.value),
          // Never let this fall through to null: the request serialises it as
          // the text "null", which every reader then treats as a real working
          // time and the vehicle becomes unbookable.
          working_time: {
            start: this.metadata.working_time.start || this.start || "",
            end: this.metadata.working_time.end || this.end || "",
          },
          accessories: this.metadata.accessories ? this.metadata.accessories : [],
        };

        let apiMethod = "create_vehicle";

        this.payloadApi = {
          clientid: this.$store.state.clientid,
          metadata: metadatas,
          type_id: this.type_id,
          origin_id: this.origin_id,
        };

        if (this.selectedVehicleGroups.length) {
          this.payloadApi.groups = this.selectedVehicleGroups.map(g => g.id).join(',');
        }

        if (!this.noGpsInstalled) {
          apiMethod = "update_vehicle";
          this.payloadApi["id"] = this.vehicle_id.id;
          this.payloadApi["deviceid"] = this.vehicle_id.deviceid;
        }

        this.loadingUpdate = true;

        this.$http
          .post(
            `${process.env.VUE_APP_API_URL}/${apiMethod}`,
            qs.stringify({
              token: this.token,
              ...this.payloadApi,
            })
          )
          .then(
            (response) => {
              if(response.data.code == 200) {
                this.$swal({
                  icon: 'success',
                  title: 'Success create vehicle',
                })
                this.close()
                this.loadData();
                this.vehicle_id = ""
                this.origin_id = ""
                this.metadata.parking_location = ""
                this.colorEnabled = false
                this.color = null
                this.metadata.vehicle_color = ""
                this.metadata.plant_no = ""
                this.metadata.engine_type = ""
                this.metadata.cabinet_id = ""
                this.metadata.cabinet_item_number = ""
                this.close()
              } else {
                this.$swal({
                  icon: 'error',
                  title: response.data.data.message,
                })
              }
            })
          .catch((error) => {
            this.$swal({
              icon: 'error',
              title: error.message,
            })
          })
          .finally(() => {
            this.loadingUpdate = false;
          });
      }
    },
    close() {
      this.dialog = false;
      this.metadata.seat_count = "";
      this.metadata.engine_type = "";
      (this.features = {
        root_rack: false,
        baby_seat: false,
        child_capsule: false,
      }),
        (this.device_id = "");
      this.$refs.form.resetValidation();
    },
    closeEdit() {
      this.no_available_periode.start_date = "";
      this.no_available_periode.end_date = "";
      this.editdialog = false;
      this.$refs.formEdit.resetValidation();
    },
    getVehicleTotal() {
      this.token = this.$store.state.token;
      this.clientid = this.$store.state.clientid;
      return this.$store.dispatch('API_CALL', {
        $method: 'get_vehicle_total',
        $postData: {
          clientid: this.$store.state.clientid,
          query: this.searchData,
          type: this.assetType
        },
      }).then((response) => {
        this.vehicleTotal = parseInt(response.data.data.total);
      })
    },
    getDataVehicles() {
      this.token = this.$store.state.token;
      this.clientid = this.$store.state.clientid;

      const { page, itemsPerPage, sortBy, sortDesc } = this.paginationOptions;
      const sort_by  = sortBy.length ? sortBy[0] : 'device_name';
      const sort_dir = sortDesc.length ? (sortDesc[0] ? 'desc' : 'asc') : 'asc';
      const offset   = (page - 1) * itemsPerPage;

      return this.$store.dispatch('API_CALL', {
          $method: 'get_vehicles',
          $postData: {
            clientid: this.clientid,
            limit: itemsPerPage,
            offset,
            sort_by,
            sort_dir,
            query: this.searchData,
            type: this.assetType,
            get_group: 1
          },
        })
        .then((response2) => {
          let vehicles = response2.data.data.map((vehicle, index) => {
            let features = get(vehicle, "metadata.features", []);
            Object.keys(features).map(function(key) {
              features[key] = features[key] == "true" ? true : false;
            });
            vehicle.no = index + 1;
            return vehicle;
          });
          this.getVehicle = vehicles;
        });
    },
    deleteItem(item) {
      this.deldialog = true;
      this.deletedIndex = this.getVehicle.indexOf(item);
      this.deletedItem = Object.assign({}, item);
    },
    editItem(item) {
      this.editId = item.id;
      this.editedIndex = this.getVehicle.indexOf(item);
      const editedItem = cloneDeep(item);
      const selectedVehicle = this.dataGPSDevice.find(d => d.id === item.id);
      editedItem.selectedVehicle = selectedVehicle;
      this.selectedVehicleGroups = editedItem.assetGroups.filter(group => group.id) || [];
      if (!editedItem.deviceid || editedItem.deviceid === '0') {
        editedItem.deviceid = '-1';
        editedItem.selectedVehicle = this.unusedGPSDeviceForEdit[0];
      }

      if (!editedItem.metadata.device_name) editedItem.metadata.device_name = selectedVehicle.name;
      if (!editedItem.metadata.device_make) editedItem.metadata.device_make = selectedVehicle.make;
      if (!editedItem.metadata.device_model) editedItem.metadata.device_model = selectedVehicle.model.split('^')[0];
      if (!editedItem.metadata.device_plate) editedItem.metadata.device_plate = selectedVehicle.reg.split('^')[0];
      if (!editedItem.metadata.seat_count) editedItem.metadata.seat_count = "";
      if (!editedItem.metadata.working_day) editedItem.metadata.working_day = [];
      if (!editedItem.metadata.working_time) editedItem.metadata.working_time = {
        start: "",
        end: "",
      };
      if (!editedItem.metadata.accessories) editedItem.metadata.accessories = [];

      this.editedfeatures = {
        root_rack: editedItem.metadata.features.root_rack ? true : false,
        baby_seat: editedItem.metadata.features.baby_seat ? true : false,
        child_capsule: editedItem.metadata.features.child_capsule
          ? true
          : false,
      },
      editedItem.metadata.features = this.editedfeatures;
      const colorEnabled = get(editedItem, 'metadata.color_enabled', 0);
      this.colorEnabled = this.getValueAsBoolean(colorEnabled);
      this.color = editedItem.metadata.vehicle_color || null;
      this.editedItem = editedItem;
      this.editdialog = true;

      this.$nextTick(() => {
        setTimeout(() => {
          this.editedItem.metadata.working_day = this.editedItem.metadata.working_day.map(
            day => {
              return this.listWorkingDays.find(d => parseInt(d.value) === parseInt(day));
            }
          );
        }, 1e3);
      });
    },
    deleteVehicle() {
      this.token = this.$store.state.token;
      const itemIndex = this.getVehicle.findIndex(
        (d) => d.id == this.deletedItem.id
      );
      const item = this.getVehicle[itemIndex];

      // const userIndex = this.getVehicle.findIndex(d => d.username == this.editedItem.username)
      this.deldialog = false;

      this.loadingUpdate = true;

      return this.$store.dispatch('API_CALL', {
          $method: 'update_vehicle',
          $postData: {
            id: item.id,
            type_id: "",
            deviceid: item.deviceid,
            clientid: item.clientid,
          },
        })
        .then(
						(response) => {
              this.loadingUpdate = false;
							if(response.data.code == 200) {
								this.$swal({
									icon: 'success',
                  title: "Success delete vehicle",
                })
                Promise.all([
                  this.loadData(),
                ]).then(() => {
                  // Total data ada, tapi di page ini kosong
                  if (this.vehicleTotal > 0 && this.getVehicle.length === 0) {
                    // reset page ke page 1
                    this.paginationOptions.page = 1
                    this.loadData();
                  }
                })
              } else {
                this.$swal({
                  icon: 'error',
                  title: response.data.data.message,
                })
              }
            })
    },
    cabinetName(item) {
      const cabinet = this.cabinets.find(
        (c) => c.id === item.metadata.cabinet_id
      );
      const name = get(cabinet, "name", "");
      return name;
    },
    getType(type) {
      if (isNaN(parseInt(type))) return "";
      const currentType = this.getVehicleType.find(
        (t) => parseInt(t.id) === parseInt(type)
      );
      return currentType ? currentType.name : "";
    },
    handleCreateVehicle() {
      this.editedIndex = null;
      this.vehicle_id = null;
      this.origin_id = null;
      this.colorEnabled = false;
      this.color = null;
      this.metadata = {
        seat_count: "",
        plant_no: "",
        engine_type: "",
        device_name: "",
        device_make: "",
        device_model: "",
        device_plate: "",
        features: {
          root_rack: false,
          baby_seat: false,
          child_capsule: false,
        },
        no_available_periode: {
          start_date: "",
          end_date: "",
        },
        parking_location: "",
        vehicle_color: "",
        cabinet_id: "",
        cabinet_item_number: "",
        working_day: [],
        working_time: {
          start: "",
          end: "",
        },
        accessories: [],
      };
      this.editedIndex = null;
      this.editedItem = {
        deviceid: "",
        type_id: "",
        clientid: "",
        id: "",
        origin_id: "",
        metadata: {
          seat_count: "",
          plant_no: "",
          engine_type: "",
          features: {
            root_rack: false,
            baby_seat: false,
            child_capsule: false,
          },
          no_available_periode: {
            start_date: "",
            end_date: "",
          },
          parking_location: "",
          vehicle_color: "",
          cabinet_id: "",
          cabinet_item_number: "",
          working_day: [],
          working_time: {
            start: "",
            end: "",
          },
          accessories: [],
        },
      };
      this.start = "";
      this.end = "";
      this.selectedVehicleGroups = [];
      if (typeof this.$refs.form === 'object') {
        this.$refs.form.resetValidation();
      }
    },
    updatePaging(options) {
      this.getVehicleTotal();
      this.paginationOptions = options;
      this.loadingData = true;
      this.getDataVehicles().then(() => {
        this.loadingData = false;
      });
    },
  },
};
</script>
<style lang="css">
.v-select.v-select--chips:not(.v-text-field--single-line).v-text-field--enclosed .v-select__selections {
  min-height: 50px !important;
}
.my-data-table table {
  table-layout: fixed;
}
.my-data-table table th {
  text-align: left;
}
.my-data-table table th.cabinet-item-no-col span {
  white-space: break-spaces;
}
</style>
